import { render } from "./Nutriendo.vue?vue&type=template&id=a15791f6&scoped=true"
import script from "./Nutriendo.vue?vue&type=script&lang=js"
export * from "./Nutriendo.vue?vue&type=script&lang=js"

import "./Nutriendo.vue?vue&type=style&index=0&id=a15791f6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a15791f6"]])

export default __exports__